// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import ScrollToTop from './components/scroll-to-top';
import { StyledChart } from './components/chart';
import ScrollToTopOnRefresh from './client/Pages/ScrollToTopOnRefresh';

// ----------------------------------------------------------------------

export default function App() {
  
  return (
    <ThemeProvider>
      <ScrollToTop />
      <ScrollToTopOnRefresh />
      <StyledChart />
      <Router />
    </ThemeProvider>
  );
}
